import React, { useEffect, useState } from "react";
import ResearchersTable from "./researchersTable";
import { getUsers, deleteUser } from "../../services/userService";
import { Container, Grid } from "@material-ui/core";
import { useSnackbar } from "notistack";
import Breadcum from "../common/breadcum";
import Loading from "../common/loading";
import ReportBySex from "./reports/reportBySex";
import { notifications } from "../../utils/messages";
import ReportByLevel from "./reports/reportByLevel";
import ReportByType from "./reports/reportByType";

const Researchers = () => {
  const [researchers, setResearchers] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const { enqueueSnackbar } = useSnackbar();

  const populateResearchers = async () => {
    setIsLoading(true);
    const { data: researchers } = await getUsers();
    setResearchers(researchers);
    setIsLoading(false);
  };

  useEffect(() => {
    populateResearchers();
  }, []);

  const getUser = (id) => {
    return researchers.find((r) => r.id === id);
  };

  const handleDelete = async (researcherId) => {
    const originalResearchers = researchers;
    const researcherToRemove = getUser(researcherId);
    const newResearchers = originalResearchers.filter(
      (researcher) => researcher !== researcherToRemove
    );
    setResearchers(newResearchers);
    try {
      await deleteUser(researcherToRemove.id);
      enqueueSnackbar(notifications.DELETE_SUCCESS, {
        variant: "success",
      });
    } catch (ex) {
      if (ex.response && ex.response.status === 404) {
        enqueueSnackbar(`${ex.response.data.message}`, {
          variant: "error",
        });
      } else if (ex.response.status === 403) {
        this.props.enqueueSnackbar(`${ex.response.data.message}`, {
          variant: "error",
        });
      }
      this.setState({ researchers: originalResearchers });
    }
  };

  const classes = {
    table: {
      padding: "2em",
      color: "secondary",
    },
  };
  return (
    <Container maxWidth="xl">
      <Loading open={isLoading} />
      <Breadcum lastLabel={"Investigadores"} />
      <ResearchersTable
        datas={researchers}
        onGetUser={getUser}
        style={classes.table}
        onDelete={handleDelete}
      />
      <Grid container spacing={3}>
        {researchers.length > 0 && (
          <>
            <ReportBySex data={researchers} />
            <ReportByType data={researchers} />
            <ReportByLevel data={researchers} />
          </>
        )}
      </Grid>
    </Container>
  );
};

export default Researchers;
